// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__rCILV","image":"Header_image__1_3m0","name":"Header_name__zXkiu","info":"Header_info__Y0n9m","infoRow":"Header_infoRow__31_VE"};